import { EnterpriseDashboardBudgetLocationMonthlyChartData } from './enterprise-dashboard-budget-location-monthly-chart-data';
import { EnterpriseDashboardLocationDetails } from './enterprise-dashboard-location-details';

export class EnterpriseDashboardBudgetLocationDetails extends EnterpriseDashboardLocationDetails {
	public totalActualCost: number;
	public totalNextBudgetCost: number;
	public monthlyBudgetActualCost: number;
	public underBudgetPercent: number;

	public monthlyChartData: EnterpriseDashboardBudgetLocationMonthlyChartData[];

	constructor(enterpriseDashboardBudgetLocationDetails?: EnterpriseDashboardBudgetLocationDetails) {
		super(enterpriseDashboardBudgetLocationDetails);
		Object.assign(this, enterpriseDashboardBudgetLocationDetails);

		this.monthlyChartData = this.monthlyChartData ? this.monthlyChartData.map(m => new EnterpriseDashboardBudgetLocationMonthlyChartData(m)) : [];
	}
}
